/*
 * Geo-targeted home collection.
 *
 * The default collection is already rendered server-side inside
 * #GeoCollectionGrid. This script resolves the visitor's country/city (cached
 * IP lookup) and, only if a different collection matches, fetches just that one
 * collection via /collections/<handle>?view=geo-strip and swaps it in.
 *
 * Locale-safe: requests are built from window.Shopify.routes.root so they keep
 * the /es and /fr path prefixes (hardcoded /collections/... breaks there).
 */
(function () {
  var root = document.getElementById('GeoCollection');
  var grid = document.getElementById('GeoCollectionGrid');
  var configEl = document.getElementById('GeoCollectionConfig');
  if (!root || !grid || !configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var map = config.map || {};
  var defaultHandle = config.default;
  if (!defaultHandle) return;

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function resolveHandle(country, city) {
    country = country || '';
    city = city || '';
    return map[country + ':' + city] || map[country] || defaultHandle;
  }

  function swapTo(handle) {
    // Default collection is already on the page — no fetch needed.
    if (!handle || handle === defaultHandle) return;

    var url = shopRoot() + 'collections/' + encodeURIComponent(handle) + '?view=geo-strip';
    fetch(url)
      .then(function (res) {
        return res.ok ? res.text() : Promise.reject(res.status);
      })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var nodes = Array.prototype.slice.call(tmp.childNodes);
        grid.replaceChildren.apply(grid, nodes);
      })
      .catch(function () {
        /* On any failure, keep the server-rendered default. */
      });
  }

  function run(country, city) {
    swapTo(resolveHandle(country, city));
  }

  // Debug override: ?geo_test=GB:Liverpool or ?geo_test=DE — skips the IP lookup.
  var override = new URLSearchParams(window.location.search).get('geo_test');
  if (override) {
    var parts = override.split(':');
    run(parts[0] || '', parts[1] || '');
    return;
  }

  // Reuse this session's geo result if we already have it.
  try {
    var cached = sessionStorage.getItem('beast_geo');
    if (cached) {
      var g = JSON.parse(cached);
      run(g.country, g.city);
      return;
    }
  } catch (e) {
    /* sessionStorage unavailable — fall through to a fresh lookup. */
  }

  fetch('https://ipapi.co/json/')
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      var country = data.country || '';
      var city = data.city || '';
      try {
        sessionStorage.setItem('beast_geo', JSON.stringify({ country: country, city: city }));
      } catch (e) {
        /* ignore storage failures */
      }
      run(country, city);
    })
    .catch(function () {
      /* IP lookup failed — keep the default collection. */
    });
})();
